import { FilterType } from './filter-type';

export class StringFilter {
  stringValue: string;
  filterType?: FilterType;
}
